export default __webpack_public_path__ + "static/media/search.20880c38.png";